import { IonIcon, IonItem, IonLabel, IonList, IonPopover, IonText } from "@ionic/react"
import { FC, ReactNode, useEffect, useId, useMemo, useRef, useState } from "react"

import { chevronDownOutline } from "ionicons/icons";
import { KeysOf } from "functions/FunnyTypes";


export const DropdownSelectItem : FC<{
  options : readonly ReactNode[],
  specialOptions?: readonly { key: number, value: ReactNode }[];
  selected : number,
  setSelected : (o: number) => void,
  label? : string,
  icon? : string,
  lines?: "none" | "inset" | "full",
}> = (props) => {
  const [selected, setSelected] = useState(0);
  const popoverRef = useRef<HTMLIonPopoverElement>(null);
  const ownId = useId()

  useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  const allOptions = useMemo(() => {
    let dict : { [k: number]: ReactNode } = {};

    for (let i = 0; i < props.options.length; i++) {
      dict[i] = props.options[i];
    }

    if (props.specialOptions) {
      for (let s of props.specialOptions) {
        console.assert(!dict[s.key], "Duplicate select option id", s.key, dict[s.key], s.value)
        dict[s.key] = s.value;
      }
    }

    return dict;
  }, [props.options, props.specialOptions]);

  return <IonItem lines={props.lines} id={`select${ownId}`} detail detailIcon={chevronDownOutline} onClick={e => {e.preventDefault()}} button style={{ width: "100%" }}>
    {props.icon === undefined ? <></> : <><IonIcon icon={props.icon} />&nbsp;</>}
    {props.label && <IonLabel>{props.label}</IonLabel>}
    <IonText>{allOptions[props.selected]}</IonText>
    <IonPopover ref={popoverRef} trigger={`select${ownId}`} alignment="end">
      <IonList>
        {KeysOf(allOptions).map(key =>
        <IonItem
          key={key}
          lines="full"
          color={selected === Number(key) ? "primary" : ""}
          className={selected === Number(key) ? "dropdown_selected" : undefined}
          onClick={e => { e.preventDefault(); props.setSelected(Number(key)); popoverRef.current?.dismiss(); }}
          button
        >
          <IonLabel>{allOptions[key]}</IonLabel>
        </IonItem>
        )}
      </IonList>
    </IonPopover>
  </IonItem>
}

